import { render, staticRenderFns } from "./make-a-worksheet-for-a-class.vue?vue&type=template&id=7e890b82&"
import script from "./make-a-worksheet-for-a-class.vue?vue&type=script&lang=js&"
export * from "./make-a-worksheet-for-a-class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports